import { Link } from 'react-router-dom';

import { useT } from '../i18n/LanguageProvider';

interface Props {
  eyebrow?: string;
  title?: string;
}

export default function CtaBand({ eyebrow, title }: Props) {
  const t = useT();

  return (
    <section className="cta-band">
      <div>
        <p className="eyebrow">{eyebrow ?? t.cta.eyebrow}</p>
        <h2>{title ?? t.cta.title}</h2>
      </div>
      <Link className="button light-button" to="/kontakt">
        {t.cta.button}
      </Link>
    </section>
  );
}
